import {
  REQUEST_LOCKOUTS,
  RECEIVE_LOCKOUTS,
  REQUEST_LOCKOUTS_ERROR,
  REQUEST_LOCKOUT_BY_WORKSPACE_SLUG,
  RECEIVE_LOCKOUT_BY_WORKSPACE_SLUG,
  REQUEST_LOCKOUT_BY_WORKSPACE_SLUG_ERROR
} from 'actions'
import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'

const initialState = {
  data: {}
}

var lockoutByWorkspaceSlugReducer = createApiMiddlewareReducer({
  request: REQUEST_LOCKOUT_BY_WORKSPACE_SLUG,
  failure: REQUEST_LOCKOUT_BY_WORKSPACE_SLUG_ERROR,
  receive: RECEIVE_LOCKOUT_BY_WORKSPACE_SLUG
})

export default function (state = initialState, { type, payload, error }) {
  switch (type) {
    case REQUEST_LOCKOUTS:
      return {
        ...state,
        isRequesting: true
      }
    case RECEIVE_LOCKOUTS:
      return {
        isRequesting: false,
        data: payload.response.reduce((memo, lockout) => {
          memo[lockout.workspaceSlug] = {
            hasRequested: true,
            data: lockout
          }
          return memo
        }, {})
      }
    case REQUEST_LOCKOUTS_ERROR:
      return {
        ...state,
        isRequesting: false,
        didRequestFail: true,
        error
      }
    case REQUEST_LOCKOUT_BY_WORKSPACE_SLUG:
    case RECEIVE_LOCKOUT_BY_WORKSPACE_SLUG:
    case REQUEST_LOCKOUT_BY_WORKSPACE_SLUG_ERROR:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.slug]: lockoutByWorkspaceSlugReducer(state.data[payload.slug], {
            type,
            payload,
            error
          })
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/lockouts.js